module.exports = __webpack_public_path__ + "img/Group 625898.a3a2a4d3.png";